/* eslint-disable max-len */
import React from 'react'
import { createIcon } from '@chakra-ui/icon'

const RightArrow = createIcon({
    viewBox: '0 0 12 10',
    displayName: 'RightArrow',
    path: (
        <path fillRule="evenodd" clipRule="evenodd" d="M0.289517 8.88872C0.0812288 9.09704 0.0812288 9.43474 0.289517 9.64306C0.497794 9.85128 0.835479 9.85128 1.04376 9.64306L5.31042 5.37634C5.51871 5.16806 5.51871 4.83038 5.31042 4.6221L1.04376 0.355435C0.835479 0.147147 0.497794 0.147147 0.289517 0.355435C0.0812288 0.563712 0.0812288 0.901397 0.289517 1.10967L4.17905 4.99922L0.289517 8.88872ZM6.68952 8.88872C6.48123 9.09704 6.48123 9.43474 6.68952 9.64306C6.89779 9.85128 7.23548 9.85128 7.44376 9.64306L11.7105 5.37634C11.9187 5.16806 11.9187 4.83038 11.7105 4.6221L7.44376 0.355435C7.23548 0.147147 6.89779 0.147147 6.68952 0.355435C6.48123 0.563712 6.48123 0.901397 6.68952 1.10967L10.5791 4.99922L6.68952 8.88872Z" fill="white" />
    ),
})

export default RightArrow